export default __webpack_public_path__ + "static/media/hotlist-logo.7f9fed8f.png";